import { handleDeleteButtonDisplayState } from "../../HandleSlice/HandleSlice";
import { useDispatch, useSelector } from "react-redux";
import * as React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MultiplePoppers from "../MultiplePoppers/MultiplePoppers";
import moment from "moment";
import TriggersTooltips from "../TriggersTooltips/TriggersTooltips";
import CheckBox from "../CheckBox/CheckBox";
const Table = (props) => {
  const { setIsCheck } = props;
  const [isCheckAll, setIsCheckAll] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const search = useLocation().search;
  const stateManagement = useSelector((state) => state);
  const inputClickHandler = (event) => {
    const data_id = event.currentTarget.getAttribute("data_id");
    const { checked } = event.target;
    for (let itemId of stateManagement.hamberger.deleteButonId) {
      if (itemId === data_id) {
        return;
      }
    }
    handleSetIsCheck(data_id, checked);
  };

  const handleSelectAll = () => {
    for (let itemId of stateManagement.hamberger.deleteButonId) {
      for (let checkItemId of props.isCheck) {
        if (itemId === checkItemId) {
          return;
        }
      }
    }
    setIsCheckAll(!isCheckAll);
    setIsCheck(props.data.data.map((li) => `${li.id}`));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleSetIsCheck = (id, checked) => {
    setIsCheck([...props.isCheck, id]);
    if (!checked) {
      setIsCheck(props.isCheck.filter((item) => item !== id));
      setIsCheckAll(false);
    } else {
      if (props.isCheck.length + 1 === props.data.data.length) {
        setIsCheckAll(true);
      }
    }
  };

  useEffect(() => {
    moment.updateLocale("fa", {
      relativeTime: {
        future: "در %s",
        past: "%s پیش",
        s: "چند لحظه",
        ss: "%d ثانیه",
        m: "1 دقیقه",
        mm: "%d دقیقه",
        h: "1 ساعت",
        hh: "%d ساعت",
        d: "1 روز",
        dd: "%d روز",
        w: "1 هفته",
        ww: "%d هفته",
        M: "1 ماه",
        MM: "%d ماه",
        y: "1 سال",
        yy: "%d سال",
      },
    });
  }, []);

  useEffect(() => {
    if (props.isCheck.length !== 0) {
      dispatch(handleDeleteButtonDisplayState(true));
    } else {
      dispatch(handleDeleteButtonDisplayState(false));
    }
  }, [props.isCheck, dispatch]);

  props.chooseIdHandler(props.isCheck);

  //when change the route should checkbox is empty and delete button is disappeared
  useEffect(() => {
    dispatch(handleDeleteButtonDisplayState(false));
    setIsCheck([]);
  }, [dispatch, setIsCheck]);

  function clickHandler(event) {
    const element = document.querySelectorAll(".tabSorting");
    const inputKeyValue =
      event.currentTarget.parentElement.getAttribute("keyvalue");
    const urlParams = new URLSearchParams(window.location.search);

    let dir = new URLSearchParams(search).get("order_dir");
    dir === "ASC" ? (dir = "DESC") : (dir = "ASC");

    urlParams.set("order_by", inputKeyValue);
    urlParams.set("order_dir", `${dir}`);
    navigate({ search: `${urlParams.toString()}` });

    for (let item of element) {
      item.childNodes[0].children[0].children[0].classList.add("hidden");
    }

    if (dir === "ASC") {
      event.currentTarget.childNodes[0].children[0].classList.remove("hidden");
      event.currentTarget.childNodes[0].children[0].classList.remove(
        "rotate-180",
      );
      event.currentTarget.childNodes[0].children[0].classList.add("rotate-0");
    } else if (dir === "DESC") {
      event.currentTarget.childNodes[0].children[0].classList.remove("hidden");
      event.currentTarget.childNodes[0].children[0].classList.remove(
        "rotate-0",
      );
      event.currentTarget.childNodes[0].children[0].classList.add("rotate-180");
    }
  }

  return (
    <table className="w-[860px] overflow-scroll 1200:w-full 1200:overflow-hidden 1200:overflow-y-auto ">
      <thead>
        <tr className="text-table_header_text dark:text-white dark:bg-[#5a646f] bg-table_header_background text-center text-[13px] h-[43px] w-full ">
          <th className="w-[100px]">
            <div className="scale-[0.23]">
              <CheckBox
                data_id={"CheckBoxHead"}
                onChange={handleSelectAll}
                checked={isCheckAll}
              />
            </div>
          </th>
          <th className={"text-[14px]"}>ردیف</th>
          {props.data.schema &&
            props.data.schema.tabname.map(
              (item) =>
                item.access && (
                  <th
                    className="tabSorting text-[14px]"
                    key={item.key}
                    keyvalue={item.key}
                  >
                    <button onClick={clickHandler}>
                      <div className="flex justify-center items-center gap-2">
                        {item.label}
                        <span className={`text-[20px] font-bold hidden`}>
                          <i className="fa fa-angle-down"></i>
                        </span>
                      </div>
                    </button>
                  </th>
                ),
            )}
          <th className="w-[100px] text-[14px]">عملیات</th>
        </tr>
      </thead>
      <tbody className="relative">
        {props.data.data &&
          props.data.data.map((item, index) => {
            return (
              <tr
                className={`text-[16px] h-[43px] w-full text-center dark:text-[#e8ebe0] ${
                  index % 2 === 0
                    ? "bg-table_body_background_even dark:bg-[#556e5355]"
                    : "bg-table_body_background_add dark:bg-[#29435C]"
                } relative`}
                key={index}
              >
                <td className="py-[20px]">
                  <div className="scale-[0.18]">
                    <CheckBox
                      data_id={`${item.id}`}
                      onChange={inputClickHandler}
                      checked={props.isCheck.includes(`${item.id}`)}
                    />
                  </div>
                </td>
                <td className={"text-[16px]"}>
                  {index +
                    1 +
                    ((props.page === null ? 1 : props.page) - 1) *
                      (props.perPage === null ? 10 : props.perPage)}
                </td>
                {props.data.schema.tabname.map((tab, indexTabName) => {
                  return (
                    tab.access && (
                      <td className="py-[20px] text-[16px]" key={indexTabName}>
                        {item[tab.key] !== undefined
                          ? (() => {
                              if (tab.type) {
                                switch (tab.type) {
                                  case "date":
                                    const tooltip = new Date(
                                      moment.unix(item[tab.key]),
                                    ).toLocaleString("fa-IR");
                                    return (
                                      <TriggersTooltips
                                        text={moment
                                          .unix(item[tab.key])
                                          .fromNow()}
                                        tooltipText={tooltip}
                                      />
                                    );
                                  case "active":
                                    return +item[tab.key] === 1 ||
                                      item[tab.key] === true ||
                                      item[tab.key] === "true" ? (
                                      <span className="text-[18px] text-green-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-check"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : +item[tab.key] === 0 ||
                                      item[tab.key] === false ||
                                      item[tab.key] === "false" ? (
                                      <span className="text-[22px] text-red-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-times-circle-o"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : (
                                      "-"
                                    );
                                  case "is_active":
                                    return +item[tab.key] === 1 ||
                                      item[tab.key] === true ||
                                      item[tab.key] === "true" ? (
                                      <span className="text-[18px] text-green-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-check"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : +item[tab.key] === 0 ||
                                      item[tab.key] === false ||
                                      item[tab.key] === "false" ? (
                                      <span className="text-[22px] text-red-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-times-circle-o"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : (
                                      "-"
                                    );
                                  case "status":
                                    return item[tab.key] === "ACCEPT" ||
                                      item[tab.key] === "SUCCEED" ? (
                                      <span className="text-[18px] text-green-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-check"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : item[tab.key] === "PENDING" ||
                                      item[tab.key] === "INIT" ? (
                                      <span className="text-[22px] text-amber-500 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-refresh"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : item[tab.key] === "FAILED" ||
                                      item[tab.key] === "REFUSE" ? (
                                      <span className="text-[22px] text-red-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-times-circle-o"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : (
                                      "-"
                                    );
                                  case "status_transaction":
                                    return item[tab.key] === "ACCEPT" ||
                                      item[tab.key] === "SUCCEED" ? (
                                      <span className="text-[18px] text-green-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-check"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : item[tab.key] === "PENDING" ||
                                      item[tab.key] === "INIT" ? (
                                      <span className="text-[22px] text-amber-500 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-refresh"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : item[tab.key] === "FAILED" ||
                                      item[tab.key] === "REFUSE" ? (
                                      <span className="text-[22px] text-red-700 flex justify-center items-center cursor-pointer">
                                        <i
                                          className="fa fa-times-circle-o"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    ) : (
                                      "-"
                                    );
                                  case "image":
                                    return (
                                      <img
                                        src={item[tab.key]}
                                        className="h-10 mx-auto scale-[160%] rounded-lg"
                                        alt={"dynamic_image"}
                                      />
                                    );
                                  case "price":
                                    return Number(
                                      item[tab.key],
                                    ).toLocaleString();
                                  case "info":
                                    return;
                                  default:
                                    return item[tab.key];
                                }
                              } else {
                                if (typeof item[tab.key] !== "object") {
                                  return item[tab.key];
                                } else {
                                  return "نامشخص";
                                }
                              }
                            })()
                          : "-"}
                      </td>
                    )
                  );
                })}
                <td>
                  <MultiplePoppers
                    item={item}
                    itemId={item.id}
                    fetchInputsData={props.fetchInputsData}
                    popperListData={
                      item.deleted
                        ? [
                            {
                              key: "restore",
                              label: "بازگردانی",
                              icon: "refresh",
                              access: true,
                            },
                          ]
                        : props.data.schema.action.list
                    }
                    location={props.location}
                    setIsCheck={setIsCheck}
                  />
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};
export default Table;
